// extracted by mini-css-extract-plugin
module.exports = {"widget-home":"style_widget-home--65wruHdv","widgetHome":"style_widget-home--65wruHdv","container":"style_container--3bh4oeMq","imageContainer":"style_imageContainer--1CY_CRjE"};